(function () {
	'use strict';
	$(document).ready(function () {
		document.querySelectorAll('.swiper-gallery').forEach((swiperContainer) => {
			new Swiper(swiperContainer, {
				slidesPerView: 1,
				pagination: {
					el: '.gallery-pagination-bullets',
					clickable: true,
					renderBullet: function (index, className) {
						return '<li class="' + className + '">' + document.querySelector(`.gallery-image-${index}`).cloneNode(true).outerHTML + '</li>';
					}
				},
			})
		});

		const select = document.querySelector('select.minimal');
		const link = document.querySelector('.contact-page-link');

		if (select) {
			select.addEventListener('change', () => {
				const url = new URL(link.href);

				if (url.searchParams.has('quantity')) {
					url.searchParams.delete('quantity');
				}

				url.searchParams.append('quantity', select.value);

				link.href = url.toString();
			});
		}


		const urlParams = new URLSearchParams(window.location.search);
		if (urlParams.has('single-product')) {
			const singleProductValue = urlParams.get('single-product');
			const singleProductInput = document.querySelector('input[name="your-product"]');

			singleProductInput.value = singleProductValue;
		}
		if (urlParams.has('quantity')) {
			const quantityValue = urlParams.get('quantity');
			const quantityInput = document.querySelector('input[name="your-quantity"]');

			quantityInput.value = quantityValue;
		}

		document.querySelectorAll('.swiper-accessories-gallery').forEach((swiperContainer) => {
			new Swiper(swiperContainer, {
				loop: false,
				slidesPerView: 3,
				spaceBetween: 6,
				observer: true,
				observeParents: true,
				navigation: {
					prevEl: '.swiper-navigation-prev',
					nextEl: '.swiper-navigation-next',
				},
				breakpoints: {
					756: {
						slidesPerView: 5,
					}
				}
			})
		});
	});
}(jQuery));
